module.exports = __webpack_public_path__ + "img/22.15424bd7.jpg";